/**
 * The meeting this app is in, from asking to join until the call has ended,
 * so that a link opened from elsewhere during it (a meeting link tapped in
 * another app) asks before leaving it (App.tsx).
 */
let current: { code: string; title: string } | null = null;

export const activeCall = {
  get: (): { code: string; title: string } | null => current,
  set(call: { code: string; title: string }): void {
    current = call;
  },
  clear(code: string): void {
    if (current?.code === code) current = null;
  },
};
